import { useEffect, useState } from 'react';
import {
  IlogisticServiceDetails,
  IlogisticServiceDetailsToolsData,
  LOCATION_PLACE_TYPE
} from '../../../../../../../types/services';
import { CONFIG_STATUS_NAME } from '../../../../../../../types/product.configuration.types';
import LsToolCardToolDataSection from './LsToolCardToolDataSection/LsToolCardToolDataSection';
import NudosDatesLogs from '../../../../../../../components/NudosComponents/NudosDatesLogs/NudosDatesLogs';
import { getAdditionalServiceDisplayElements } from '../../../../../../../utils/logisticServices.utils';
import { PRODUCT_CATEGORY } from '../../../../../../../types/category';
import { IdateLog } from '../../../../../../../types/global';
import { ToolAdditionalServicesOrConfigurationsSection } from '../../../../../../../components';

import './LogisticServiceToolCard.scss';

const LogisticServiceToolCard = ({
  toolData,
  logisticServiceData,
  updateDataCallback
}: {
  toolData: IlogisticServiceDetailsToolsData;
  logisticServiceData?: IlogisticServiceDetails | null;
  updateDataCallback: () => Promise<void>;
}) => {
  const [additionalServicesDates, setAdditionalServicesDates] = useState<IdateLog[]>();
  const { logisticAdditionalServices, category } = toolData;
  const { destinationLocation, originLocation } = logisticServiceData || {};

  const datesTitle = 'Historial de la herramienta';
  const hasDatesToShow = !!additionalServicesDates?.length;
  const originIsWarehouse = originLocation?.place === LOCATION_PLACE_TYPE.NUDOS;
  const destinationIsWarehouse = destinationLocation?.place === LOCATION_PLACE_TYPE.NUDOS;
  const originOrDestinationIsWarehouse = originIsWarehouse || destinationIsWarehouse;
  const additionalServicesData = {
    productId: Number(toolData.productId),
    additionalServices: toolData.logisticAdditionalServices || []
  };

  const toolCouldHaveAdditionalServices = [
    PRODUCT_CATEGORY.LAPTOP,
    PRODUCT_CATEGORY.PC,
    PRODUCT_CATEGORY.CTO_LAPTOPS,
    PRODUCT_CATEGORY.DEP_LAPTOPS
  ].includes(category as PRODUCT_CATEGORY);

  const showAdditionalServicesSection = originOrDestinationIsWarehouse && toolCouldHaveAdditionalServices;

  const getAdditionalServicesDates = () =>
    logisticAdditionalServices?.reduce<{ label: string; date: string }[]>(
      (allAdditionalServicesDates, thisAdditionalService) => {
        const { text = 'Sin nombre' } = thisAdditionalService?.status
          ? getAdditionalServiceDisplayElements(thisAdditionalService)
          : {};
        const thisServiceLogs = thisAdditionalService?.statusLog || [];
        const thisAdditionalServiceDates = thisServiceLogs
          .filter(log => log.statusName !== CONFIG_STATUS_NAME.TO_COMPLETE)
          .map(log => {
            return {
              label: `${text} - ${log?.statusName?.toLowerCase() || 'Sin estado'}`,
              date: log.createdAt || 'Sin datos'
            };
          });
        return allAdditionalServicesDates.concat(thisAdditionalServiceDates);
      },
      []
    );

  useEffect(() => {
    if (!logisticAdditionalServices?.length) return;
    const allDates = getAdditionalServicesDates();
    setAdditionalServicesDates(allDates);
  }, [logisticAdditionalServices]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="logisticServiceToolCard">
      <div className="topSection">
        <LsToolCardToolDataSection
          toolData={toolData}
          logisticServiceData={logisticServiceData}
          updateDataCallback={updateDataCallback}
          organizationInfo={logisticServiceData?.organization}
        />
        {hasDatesToShow && <NudosDatesLogs title={datesTitle} dates={additionalServicesDates || []} />}
      </div>

      {showAdditionalServicesSection && <div className="sectionDivider" />}
      {showAdditionalServicesSection && (
        <ToolAdditionalServicesOrConfigurationsSection
          showExternalWipingSection={destinationIsWarehouse}
          updateDataCallback={updateDataCallback}
          additionalServicesData={additionalServicesData}
        />
      )}
    </div>
  );
};

export default LogisticServiceToolCard;
